'use client';
import { ReactNode, useEffect, useState } from 'react';
import { LeagueHeader } from './league-header';
import { CardProps } from '../../types';
import { SportMatchModel } from '@nf/types/odds';
import { CardItem } from './card-item';
export const Card = ({
	Matches,
	LeagueName,
	isExpand,
	sportId,
	leagueIdForMyFavourite: LeagueId,
	LeagueGroupId,
}: CardProps) => {
	const [isLeagueExpand, setIsLeagueExpand] = useState<boolean>(isExpand)
	useEffect(() => {
		isExpand && setIsLeagueExpand(true)
	}, [isExpand])
	return (
		<>
			<LeagueHeader 
				isLeagueExpand={isLeagueExpand}
				setIsLeagueExpand={setIsLeagueExpand}
				sport={sportId}
				leagueId={LeagueId}
				leagueIdForMyFavourite={ LeagueId}
				leagueGroupId={LeagueGroupId}
				leagueName={LeagueName}
				parentMatchId={Matches[0].Parentmatchid}
				matchsCount={Matches.length}
			/>
			<div className="match-group">
				{Matches.map((match: SportMatchModel) => (
					<CardItem
						key={match.MatchId}
						match={match}
						isLeagueExpand={isLeagueExpand}
						sportId={sportId}
					/>
				))}
			</div>
		</>
	);
}

